import { Button, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import TRACKING_IDS from 'tracking-ids';

import type { ReactNode } from 'react';

// Mantine's red, which is the Hatch "Red Stop" colour in design/DESIGN.md. The toast's accent
// bar and its "Reload now" button both use it.
export const SESSION_CHANGED_COLOR = 'red';

type SessionChangedMessageProps = {
  onReload: () => void;
  onDismiss: () => void;
};

/**
 * Body of the warning that SessionChangedNotifier shows: the explanation and the two choices.
 */
export function SessionChangedMessage({
  onReload,
  onDismiss,
}: SessionChangedMessageProps): ReactNode {
  const { t } = useTranslation(['Session']);

  return (
    <Stack gap="sm">
      <Text size="sm">{t('Session:identityGuard.message')}</Text>
      <Group justify="flex-end" gap="xs">
        <Button
          size="xs"
          variant="subtle"
          color="gray"
          onClick={onDismiss}
          data-tracking-id={TRACKING_IDS.hatch.sessionChanged.reloadLater}
        >
          {t('Session:identityGuard.reloadLater')}
        </Button>
        <Button
          size="xs"
          color={SESSION_CHANGED_COLOR}
          onClick={onReload}
          data-tracking-id={TRACKING_IDS.hatch.sessionChanged.reloadNow}
        >
          {t('Session:identityGuard.reloadNow')}
        </Button>
      </Group>
    </Stack>
  );
}
